import React from 'react';
import { useNavigate } from 'react-router-dom';
import FormActions from '@/components/shared/FormActions';

interface InvoiceFormActionsProps {
  estimateId: string;
  isCreating: boolean;
  isEditMode?: boolean;
  invoiceId?: string;
}

const InvoiceFormActions: React.FC<InvoiceFormActionsProps> = ({
  estimateId,
  isCreating,
  isEditMode = false,
  invoiceId,
}) => {
  const navigate = useNavigate();
  const cancelPath = isEditMode && invoiceId ? `/invoices/${invoiceId}` : `/estimates/${estimateId}`;

  return (
    <FormActions
      onCancel={() => navigate(cancelPath)}
      isSubmitting={isCreating}
      submitLabel={isEditMode ? 'Update Invoice' : 'Create Invoice'}
      submittingLabel={isEditMode ? 'Updating...' : 'Creating...'}
    />
  );
};

export default InvoiceFormActions;
